var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticStyle: { "padding-bottom": "50px" },
      attrs: { "data-comp": "CameraTestProxy" },
    },
    [_c(_vm.testComponent, { tag: "component" })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }